module.exports = __webpack_public_path__ + "img/testimonials-bgr.b7ddc10a.svg";